<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"/>
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
  </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord() {
      let item = this.params.data;
      // 1. Set current row item to store
      this.$store.dispatch('setSettingCategoryItem', item)
      // 2. Set pop up title
      this.$store.dispatch('setCategoryPopUpTitle', `Επεξεργασία κατηγορίας ${item.name}`)
      // 3. Open pop up
      this.$store.dispatch('setCategoryPopUpStatus', true)
      // this.$parent.$parent.editRecord(this.item);
      //    this.$router.push("settings/sources/edit/" + this.params.data.id).catch(() => {})
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Επιβεβαίωση διαγραφής',
        text: `Πρόκειται να διαγράψετε την εγγραφή "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Διαγραφή'
      })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch("deleteSettingCategory", this.params.data.id)
          .then(() => {
            this.showDeleteSuccess()
          })
          .catch(err => {
            console.error(err)
          })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'Η εγγραφή διαγράφηκε',
        position: 'top-right',
        text: 'Η επιλεγμένη εγγραφή διαγράφηκε με επιτυχία'
      })
    }
  }
}
</script>
